export const projects = [
  {
    id: 1,
    name: "Mentor-Mentee Platform",
    description: "Developed dashboards for real-time performance tracking and an optimal assignment system handling 6 different field constraints and 340 average weekly requests. Secured 2nd place at Opportunity Hack 2024.",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800",
    tags: ["Python", "Flask", "AWS Lambda", "DynamoDB", "S3"],
    github: "https://github.com/McHarold404/mentor-mentee-platform",
    demo: "#",
    featured: true,
    period: "Oct 2024 – Feb 2025",
  },
  {
    id: 2,
    name: "LLM-Based Financial Research Tool",
    description: "Automating financial research analytics for evaluating pricing position of a company leveraging LLMs. Exploring conversation chains and LLM agents in LangChain. Using ChromaDB for storing and indexing.",
    image: "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*bytrK3M-k2q94JzSSpdl0Q.jpeg",
    tags: ["LangChain", "LLMs", "ChromaDB", "Python"],
    github: "https://github.com/McHarold404/financial-research-tool",
    featured: true,
    period: "2024",
  },
  {
    id: 3,
    name: "C-Shell (She Sells C Shells)",
    description: "Implemented an advanced Linux shell in C++ supporting I/O redirection, piping, and custom signal handling. Extended MIT's legacy xv6 OS, adding priority-based and MLFQ scheduling.",
    image: "https://images.unsplash.com/photo-1629654297299-c8506221ca97?w=800",
    tags: ["C++", "Operating Systems", "Shell"],
    github: "https://github.com/McHarold404/C-Shell",
    featured: true,
    period: "Sep 2022",
  },
  {
    id: 4,
    name: "Job Searching Web Application",
    description: "Built a full-stack portal enabling 200+ students to apply for jobs with a real-time React dashboard. Implemented fuzzy string matching to enhance job search accuracy and user experience.",
    image: "https://www.rlogical.com/wp-content/uploads/2020/12/MERN.webp",
    tags: ["React", "Node.js", "Express", "MongoDB"],
    github: "https://github.com/McHarold404/MERN-Job-Portal",
    demo: "#",
    featured: true,
    period: "Jan 2022 – Mar 2022",
  },
  {
    id: 5,
    name: "Wikipedia Search Engine (SIS Engine)",
    description: "Engineered a multi-threaded indexer and search engine for 500K+ Wikipedia articles. Implemented the BM25 ranking algorithm, achieving sub-0.1s latency for top-5 search results.",
    image: "https://user-images.githubusercontent.com/74975220/255162639-ab3cc010-6d6f-48db-be46-10b3db1895e0.png",
    tags: ["C++", "Information Retrieval", "BM25", "Multi-threading"],
    github: "https://github.com/McHarold404/Wikipedia-Search-Engine",
    featured: true,
    period: "Jun 2021",
  },
  {
    id: 6,
    name: "Clash of Clans - Terminal Game",
    description: "Feature-rich, Terminal based game, employing Python and comprehensive OOP principles (Encapsulation, Inheritance, Abstraction, and Polymorphism) and OS multi-threading and asynchronous I/O operations.",
    image: "https://images.unsplash.com/photo-1511512578047-dfb367046420?w=800",
    tags: ["Python", "OOP", "Game Development", "Multi-threading"],
    github: "https://github.com/McHarold404/Clash-of-Titans",
    period: "2021",
  },
  {
    id: 7,
    name: "DBManager - SQL CLI",
    description: "Sophisticated search operations, multi-field data updates, and record maintenance. Enhanced user experience by efficient handling of complex queries and database management.",
    image: "https://www.freecodecamp.org/news/content/images/2020/08/Untitled-design-1-.png",
    tags: ["SQL", "Database", "CLI"],
    github: "https://github.com/McHarold404/DBMS_GYMS",
    period: "2021",
  },
];
